module.exports = __webpack_public_path__ + "img/Index3.6d5e438f.png";